<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    @if (existing) {
      {{ 'site.changeBlueprint' | translate }}
    } @else {
      {{ 'sites.addFloor' | translate }}
    }
  </div>
  <form [formGroup]="formGroup">
    <ion-item lines="none"
      [disabled]="existing != null">
      <ion-input autocapitalize="on"
        formControlName="name"
        [placeholder]="'item.name' | translate"></ion-input>
    </ion-item>
    @if (formGroup.value.url === '') {
      <ion-button color="light"
        shape="round">
        <form method="post"
          enctype="multipart/form-data"
          class="input-form">
          <label class="input-label"
            for="file">
            <input id="file"
              accept="image/*"
              type="file"
              name="file"
              (change)="addBlueprint($event)" />
            {{ 'site.addBlueprint' | translate }}
          </label>
        </form>
      </ion-button>
    } @else {
      <ion-item color="primary"
        lines="none">
        <img [src]="formGroup.value.url" />
        <ion-icon slot="end"
          color="danger"
          name="remove-circle-outline"
          (click)="removeImg()"></ion-icon>
      </ion-item>
    }
    <div class="ion-margin-top">
      <ion-button color="light"
        shape="round"
        [disabled]="formGroup.invalid"
        (click)="save()">
        {{ 'general.save' | translate }}
      </ion-button>
    </div>
  </form>
</app-main-dialog>